import api from "./api";

export interface BlockTime {
  id: number;
  company_id: number;
  employee_id: number;
  employee_name?: string | null;
  date: string;
  start_time: string;
  end_time: string;
  start: string;
  end: string;
  title: string;
  reason?: string | null;
}

export interface BlockTimePayload {
  employee_id: number;
  date: string;
  start_time: string;
  end_time: string;
  title?: string;
  reason?: string;
}

export async function getBlockTimes(params: {
  start_date: string;
  end_date: string;
  employee_id?: number;
}): Promise<BlockTime[]> {
  const response = await api.get("/admin/block-times", { params });
  return response.data?.blocked_times || [];
}

export async function getBlockTime(id: number): Promise<BlockTime> {
  const response = await api.get(`/admin/block-times/${id}`);
  return response.data.blocked_time;
}

export async function createBlockTime(
  payload: BlockTimePayload
): Promise<BlockTime> {
  const response = await api.post("/admin/block-times", payload);
  return response.data.blocked_time;
}

export async function updateBlockTime(
  id: number,
  payload: Partial<BlockTimePayload>
): Promise<BlockTime> {
  const response = await api.put(`/admin/block-times/${id}`, payload);
  return response.data.blocked_time;
}

export async function deleteBlockTime(id: number): Promise<void> {
  await api.delete(`/admin/block-times/${id}`);
}
